import React, { useState, useEffect } from "react";
import "Style/Layouts/dashboardLayout.scss";
import "../../pages/MobilePages/PanelPages/panel.scss";
import { ToastContainer } from "react-toastify";
import TopMenuMobile from "./Components/DashboardTopMenuMobile";
import SideMenuMobile from "./Components/DashboardSideMenuMobile";
import { useNavigate } from "react-router-dom";
interface Props {
  Component: any;
}

const DashboardMobileLayout: React.FC<Props> = ({ Component }) => {
  const [isDrawerOpen, setIsDrawerOpen] = useState<boolean>(false);
  const navigate = useNavigate();
  useEffect(() => {
    setIsDrawerOpen(false)
  }, [navigate]);

  return (
    <>
      <div
        style={{
          background: isDrawerOpen
            ? "rgba(0, 0, 0, 0.5)"
            : "rgba(0, 0, 0, 0.0)",
          width: "100vw",
          height: "100vh",
          position: "fixed",
          zIndex: isDrawerOpen ? "200" : "-1",
          transition: "0.2s",
        }}
        onClick={() => setIsDrawerOpen(false)}
      ></div>
      <div
        className="mobile"
        style={{
          height: isDrawerOpen ? " 100vh" : "",
          overflow: isDrawerOpen ? "hidden" : "",
        }}
      >
        <div style={{ height: isDrawerOpen ? "60px" : "" }}>
          <TopMenuMobile
            isDrawerOpen={isDrawerOpen}
            setIsDrawerOpen={setIsDrawerOpen}
          />
        </div>

        <SideMenuMobile
          isDrawerOpen={isDrawerOpen}
          setIsDrawerOpen={setIsDrawerOpen}
        />
        <div className="component-container">{Component}</div>
        <ToastContainer
          autoClose={3000}
          position="top-left"
          className="toast-container"
        />
      </div>
    </>
  );
};

export default DashboardMobileLayout;
